import React from 'react'

const AboutCommunity = () => {
  return (
    <div>AboutCommunity</div>
  )
}

export default AboutCommunity